// extracted by mini-css-extract-plugin
export default {"container":"ProjectAction_container__PCKWX","deleteIcon":"ProjectAction_deleteIcon__rXL6Q","icon":"ProjectAction_icon__j2SfT"};